import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  mockInsightsAudit,
  mockInsightsFailures,
  mockInsightsOverview,
  mockInsightsTesters,
} from '../../data/mock-insights-data';
import {
  InsightsAuditEntry,
  InsightsFailure,
  InsightsOverview,
  InsightsTester,
} from '../../models/insights';
import { UtilityService } from '../utility/utility.service';

@Injectable({ providedIn: 'root' })
export class InsightsService {
  private utilityService = inject(UtilityService);

  private endpoint = `${environment.testHubApiUrl}/v1/Insights`;

  getOverview(releaseId: number): Observable<InsightsOverview> {
    if (environment.useMockData) return of(mockInsightsOverview);
    return this.utilityService.getRequest<InsightsOverview>(`${this.endpoint}/${releaseId}/Overview`);
  }

  getTesters(releaseId: number): Observable<InsightsTester[]> {
    if (environment.useMockData) return of(mockInsightsTesters);
    return this.utilityService.getRequest<InsightsTester[]>(`${this.endpoint}/${releaseId}/Testers`);
  }

  getFailures(releaseId: number): Observable<InsightsFailure[]> {
    if (environment.useMockData) return of(mockInsightsFailures);
    return this.utilityService.getRequest<InsightsFailure[]>(`${this.endpoint}/${releaseId}/Failures`);
  }

  getAudit(releaseId: number): Observable<InsightsAuditEntry[]> {
    if (environment.useMockData) return of(mockInsightsAudit);
    return this.utilityService.getRequest<InsightsAuditEntry[]>(`${this.endpoint}/${releaseId}/Audit`);
  }
}
